import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { FundingMaState } from "@/types/fundingMa";

import { FundingMa } from "../../pages/FundingMa/schema/funding-ma";
import { fundingMaApi } from "./fundingMa.api";

const initialState: FundingMaState = {
	fundingMas: {
		data: [],
		meta: {
			page: 1,
			limit: 15,
			itemCount: 15,
			pageCount: 1,
			hasPreviousPage: false,
			hasNextPage: false,
		},
	},
};

export const fundingMaSlice = createSlice({
	name: "fundingMa",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			fundingMaApi.endpoints.createFundingMa.matchFulfilled,
			(state, { payload }: PayloadAction<FundingMa>) => {
				if (payload && state.fundingMas?.data) {
					state.fundingMas.data.push(payload);
				}
			}
		);
	},
});

export const fundingMaReducer = fundingMaSlice.reducer;
export const fundingMaSelector = (state: RootState) => state[fundingMaSlice.name];
